import { Color } from '@thiememeulenhoff/tokens';
import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ContentModalComponent } from '../content/content.component';
import { styles, tag } from './confirmation.styles';

@customElement(tag)
export class ConfirmationModelComponent extends ContentModalComponent {
  static override styles = [...super.styles, styles];

  @property({ type: String, attribute: 'confirm-color' })
  confirmColor: Color = 'blue';

  @property({ type: String, attribute: 'confirm-label' })
  confirmLabel = 'Bevestigen';

  @property({ type: Boolean, attribute: 'confirm-disabled' })
  confirmDisabled = false;

  @property({ type: String, attribute: 'confirm-data-test' })
  confirmDataTest = 'modal.button.confirm';

  @property({ type: String, attribute: 'cancel-label' })
  cancelLabel = 'Annuleren';

  @property({ type: String, attribute: 'cancel-data-test' })
  cancelDataTest = 'modal.button.cancel';

  @property({ type: String, attribute: 'sticky-footer' })
  stickyFooter = false;

  @property({ type: Boolean, attribute: 'custom-confirm', reflect: true })
  customConfirm = false;

  closing = false;

  override extraControls() {
    return html`<footer>
      <a-button
        color=${this.confirmColor}
        ?disabled=${this.confirmDisabled}
        data-test=${this.confirmDataTest}
        @click=${this.confirm}
      >
        ${this.confirmLabel}
      </a-button>
      <a-button
        color="blue"
        variant="ghost"
        data-test=${this.cancelDataTest}
        @click=${this.close}
      >
        ${this.cancelLabel}
      </a-button>
    </footer>`;
  }

  override dialogContent() {
    return html`<container part="container">
      ${this.header()}
      <main
        part="main"
        id="content"
        class="${this.stickyFooter ? 'scrollable' : ''}"
      >
        <slot></slot>
      </main>
      ${this.extraControls()} ${this.closeButton()}
    </container>`;
  }

  confirm() {
    if (this.closing) {
      return;
    }

    if (this.customConfirm) {
      this.dispatchGlobalEvent({
        eventName: 'modalConfirm',
      });

      return;
    }

    this.close('confirm');
  }

  override close(closeReason?: string) {
    this.closing = true;
    super.close(closeReason);
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'a-confirmation-modal': ConfirmationModelComponent;
  }
}
